import { BASE_URL, request } from "./api";
import type {
  Paciente,
  PacienteRequestDto,
  PacienteUpdateRequestDto,
} from "./types";

// Re-export types
export type { Paciente };

// GET /api/Paciente
export const getPacientes = async (): Promise<Paciente[]> => {
  return request<Paciente[]>(`${BASE_URL}/api/Paciente`, { method: "GET" });
};

// POST /api/Paciente
export const createPaciente = async (
  data: PacienteRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Paciente`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// GET /api/Paciente/{id}
export const getPacienteById = async (id: number): Promise<Paciente> => {
  return request<Paciente>(`${BASE_URL}/api/Paciente/${id}`, { method: "GET" });
};

// PUT /api/Paciente/{id}
export const updatePaciente = async (
  id: number,
  data: PacienteUpdateRequestDto
): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Paciente/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: data,
  });
};

// DELETE /api/Paciente/{id}
export const deletePaciente = async (id: number): Promise<void> => {
  return request<void>(`${BASE_URL}/api/Paciente/${id}`, { method: "DELETE" });
};
